import { render, staticRenderFns } from "./SendBrochureRequestEmail.vue?vue&type=template&id=8da6dc3e&"
import script from "./SendBrochureRequestEmail.vue?vue&type=script&lang=js&"
export * from "./SendBrochureRequestEmail.vue?vue&type=script&lang=js&"
import style0 from "./SendBrochureRequestEmail.vue?vue&type=style&index=0&id=8da6dc3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports